import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col xl:flex-col md:flex-wrap md:flex-row bg-brown text-left" }
const _hoisted_2 = { class: "pl-4 md:pl-6 xl:pl-8 border-b border-white border-opacity-20 w-full md:w-1/2 xl:w-full" }
const _hoisted_3 = { class: "sf-pro font-semibold text-base leading-[21px] xl:text-xl xl:leading-[28px] text-muted mt-6 xl:mt-8" }
const _hoisted_4 = { class: "mt-4 xl:mt-5 mb-6 xl:mb-8 flex" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col ml-4 my-[7.5px]" }
const _hoisted_7 = { class: "flex-1 text-white sf-pro font-medium text-2xl leading-100p xl:font-semibold xl:leading-[32px]" }
const _hoisted_8 = { class: "flex-1 text-ternary sf-pro font-normal text-sm leading-[21px] xl:text-[13px]" }
const _hoisted_9 = {
  key: 0,
  class: "pl-4 md:pl-0 xl:pl-8 border-b border-white border-opacity-20 w-full md:w-1/2 xl:w-full"
}
const _hoisted_10 = { class: "text-muted mt-6 xl:mt-8 sf-pro font-semibold text-base leading-[21px] xl:text-xl xl:leading-[28px]" }
const _hoisted_11 = { class: "flex gap-2 mt-4 xl:mt-5 mb-6 md:mb-[41px] xl:mb-8" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 1,
  class: "px-4 md:px-6 xl:px-8 border-b border-white border-opacity-20 w-full"
}
const _hoisted_14 = { class: "text-muted sf-pro font-semibold text-base leading-[21px] xl:text-xl xl:leading-[28px] mt-6 xl:mt-8" }
const _hoisted_15 = { class: "mt-5 mb-6 xl:mb-8 flex flex-row flex-wrap xl:flex-col gap-y-[16px] xl:gap-y-[24px] max-h-[368px] md:max-h-[176px] xl:max-h-[395px] overflow-y-auto no-scrollbar" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "flex flex-col ml-4" }
const _hoisted_19 = { class: "text-muted sf-pro-xs mb-1" }
const _hoisted_20 = { class: "flex-1 text-ternary sf-pro font-semibold text-base leading-[21px] xl:font-medium xl:leading-[24px]" }

import { computed } from "vue";
import { Author, AuthorTranslation, RelatedBlog } from "@/types/blogs";
import { useLangStore } from "@/stores/langStore";

import facebook from "@/assets/icons/social/facebook.svg";
import messenger from "@/assets/icons/social/messenger.svg";
import telegram from "@/assets/icons/social/telegram.svg";
import viber from "@/assets/icons/social/viber.svg";
import x from "@/assets/icons/social/x.svg";
import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogSidebar',
  props: {
    author: {},
    relatedBlogs: {}
  },
  setup(__props: any) {

const props = __props;

const socials = [
  { src: facebook, alt: "Facebook" },
  { src: messenger, alt: "Messenger" },
  { src: telegram, alt: "Telegram" },
  { src: viber, alt: "Viber" },
  { src: x, alt: "X" },
];

const languageStore = useLangStore();

const { t } = useI18n();
const router = useRouter();

const currentAuthor = computed<AuthorTranslation>(
  () =>
    props.author[languageStore.current] ||
    props.author[languageStore.fallbackLang]
);

function openRelatedBlog(relatedBlog: RelatedBlog) {
  router.push({
    name: ROUTE_NAMES.BLOG_DETAIL,
    params: { id: relatedBlog.id },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("blog_detail.article_author")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: props.author?.photo_url,
          alt: "Author Photo",
          class: "w-[72px] h-[72px] rounded-full"
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(currentAuthor.value?.name ?? ""), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(currentAuthor.value?.position ?? ""), 1)
        ])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("blog_detail.share_with_friends")), 1),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (s) => {
              return _createElementVNode("img", {
                key: s.name,
                class: "cursor-pointer",
                src: s.src,
                alt: s.alt
              }, null, 8, _hoisted_12)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    (props.relatedBlogs.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)("blog_detail.similar_articles")), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.relatedBlogs, (relatedBlog) => {
              return (_openBlock(), _createElementBlock("div", {
                key: relatedBlog.id,
                class: "flex cursor-pointer w-full md:w-1/2 xl:w-full",
                onClick: ($event: any) => (openRelatedBlog(relatedBlog))
              }, [
                _createElementVNode("img", {
                  src: relatedBlog.image_url,
                  alt: "Related Blog Img",
                  class: "w-[110px] h-20 rounded-[10px] object-cover"
                }, null, 8, _hoisted_17),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(relatedBlog.created_at), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(relatedBlog.titles[_unref(languageStore).current] ||
                relatedBlog.titles[_unref(languageStore).fallbackLang]), 1)
                ])
              ], 8, _hoisted_16))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})